import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  step: 1,
  PersonalInfo: { name: "", email: "", phone: "" },
  error: { nameError: "", emailError: "", phoneError: "" },
  planDuration: "Monthly",
  plan: {
  name: "Arcade",
  price: 9,
  yearlyPrice: 90
},
  addOns: [
    { id: 1, addOnInfo: "Online service", desc: "Access to multiplayer games", price: "1", yearlyPrice: "10", checked: false },
    { id: 2, addOnInfo: "Larger storage", desc: "Extra 1TB of cloud save", price: "2", yearlyPrice: "20", checked: false },
    { id: 3, addOnInfo: "Customizable profile", desc: "Custom theme on your profile", price: "2", yearlyPrice: "20", checked: false }
  ],
  AddonsAmount: 0,
  Total: 9,
}

const MainReducer = createSlice({
  name: "MainReducer",
  initialState,
  reducers: {

    setStep: (state, action) => {
      state.step = action.payload
    },

    IncrementStep: (state) => {
      state.step += 1
    },

    DecrementStep: (state) => {
      state.step -= 1
    },

    setPersonalInfo: (state, action) => {
      state.PersonalInfo = { ...state.PersonalInfo, ...action.payload }
    },

    setPlan: (state, action) => {
      state.plan = action.payload
    },

    

    setPlanDuration: (state) => {
      state.planDuration=state.planDuration==="Yearly"?"monthly":"Yearly"
    },

    setError: (state, action) => {
      state.error = { ...state.error, ...action.payload }
    },

    clearError: (state) => {
      state.error = { nameError: "", emailError: "", phoneError: "" }
    },

    selectedPlan: (state, action) => {
      state.plan = action.payload
    },

    setAddOns: (state, action) => {
      state.addOns = action.payload
    },
   setTotal: (state) => {
  const planPrice =
    state.planDuration === "Yearly"
      ? Number(state.plan.yearlyPrice || 0)
      : Number(state.plan.price || 0);

  const addonsTotal = state.addOns.reduce((acc, item) => {
    if (!item.checked) return acc;

    return acc + Number(
      state.planDuration === "Yearly"
        ? item.yearlyPrice
        : item.price
    );
  }, 0);

  state.Total = planPrice + addonsTotal;
}
  }
})

export const {
  setStep,
  setPersonalInfo,
  IncrementStep,
  DecrementStep,
  setPlan,
  setError,
  clearError,
  setPlanDuration,
  togglePlanDuration,
  selectedPlan,
  setAddOns,
  setTotal
} = MainReducer.actions

export default MainReducer.reducer